module.exports = "/assets/data/2f6a901900c6686577354e4ff0581771-B18.data.json";